import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import ItemLotTabs from "./ItemLotTabs";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import LotDataEntryPopup from "../../../../../im/codes/lotDataEntry/common/LotDataEntryPopup";
import SalesOrderOptionsButton, { OptionsTabType } from "../common/SalesOrderOptionsButton";
import PrintReportMenu from "../common/PrintReportMenu";
const ItemLotSearchResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "bf666983-13d1-4b11-ae5a-3088369f4efc";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const childRef = useRef();
    const [showPopup, setShowPopup] = useState({id:null,visible:false});
    const [selectedRecord, setSelectedRecord] = useState(null);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
          }
        setSelectedRecord(selectedRowData);
        setShowPopup({id:selectedRowData.lotRowId,visible:false});
    };
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
             ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                <Column dataField="lotcode" caption="Lot" />
                <Column dataField="itemCode" caption="Item" />
                <Column dataField="itemDescription1" caption="Item Description 1" />
                <Column dataField="lotDescription1" caption="Lot Description 1" />
                <Column dataField="lotInventoryStatus.lotNetAvailable" caption="Lot Net Available" />
                <Column dataField="wareHouse" caption="Warehouse" />
                <Column dataField="lotDescription2" caption='Lot Description 2' visible={false}></Column>
                <Column dataField="lotClasscode" caption='Lot Class Code' visible={false}></Column>
                <Column dataField="lotSubclasscode" caption='Lot Subclass Code' visible={false}></Column>
                <Column dataField="lotDateavailable" caption='Lot Date Available' visible={false}></Column>
                <Column dataField="lotOversellpercentage" caption='Lot Oversell Percentage' visible={false}></Column>
                <Column dataField="lotInventoryStatus.lotOnhand" caption="Lot On Hand" visible={false} />
                <Column dataField="lotInventoryStatus.lotInReceiving" caption="Lot In Receiving" visible={false} />
                <Column dataField="lotInventoryStatus.lotOutShipped" caption="Lot Out Shipped" visible={false} />
                <Column dataField="lotInventoryStatus.lotInUnavailable" caption="Lot In Unavailable" visible={false} />
                <Column dataField="lotInventoryStatus.lotOutUnavailable" caption="Lot Out Unavailable" visible={false} />
                <Column dataField="lotInventoryStatus.lotAvailable" caption="Lot Available" visible={false} />
                <Column dataField="lotInventoryStatus.lotInOrdered" caption="Lot In Ordered" visible={false} />
                <Column dataField="lotInventoryStatus.lotOutOrdered" caption="Lot Out Ordered" visible={false} />
                <Column dataField="lotInventoryStatus.lotInBackorder" caption="Lot In Backorder" visible={false} />
                <Column dataField="lotInventoryStatus.lotOutBackorder" caption="Lot Out Backorder" visible={false} />
                <Column dataField="lotInventoryStatus.lotInFuture" caption="Lot In Future" visible={false} />
                <Column dataField="lotInventoryStatus.lotOutFuture" caption="Lot Out Future" visible={false} />
                <Column dataField="itemDescription2" caption="Item Description 2" visible={false} />
                <Column dataField="itemSubclasscode" caption="Item Subclass Code" visible={false} />
                <Column dataField="itemClasscode" caption="Item Class Code" visible={false} />
                <Column dataField="itemCode1" caption="Item Code 1" visible={false} />
                <Column dataField="itemCode2" caption="Item Code 2" visible={false} />
                <Column dataField="itemCode3" caption="Item Code 3" visible={false} />
                <Column dataField="itemCode4" caption="Item Code 4" visible={false} />
                <Column dataField="itemCode5" caption="Item Code 5" visible={false} />
                <Column dataField="itemCode6" caption="Item Code 6" visible={false} />
                <Column dataField="itemCode7" caption="Item Code 7" visible={false} />
                <Column dataField="itemCode8" caption="Item Code 8" visible={false} />
                <Column dataField="itemCode9" caption="Item Code 9" visible={false} />
                <Column dataField="itemCode10" caption="Item Code 10" visible={false} />
                <Column dataField="itemReference1" caption="Item Reference 1" visible={false} />
                <Column dataField="itemReference2" caption="Item Reference 2" visible={false} />
                <Column dataField="itemReference3" caption="Item Reference 3" visible={false} />
                <Column dataField="itemReference4" caption="Item Reference 4" visible={false} />
                <Column dataField="itemReference5" caption="Item Reference 5" visible={false} />
                <Column dataField="itemReference6" caption="Item Reference 6" visible={false} />
                <Column dataField="itemReference7" caption="Item Reference 7" visible={false} />
                <Column dataField="itemReference8" caption="Item Reference 8" visible={false} />
                <Column dataField="itemReference9" caption="Item Reference 9" visible={false} />
                <Column dataField="itemReference10" caption="Item Reference 10" visible={false} />
                <Column dataField="itemDate1" caption="Item Date 1" visible={false} />
                <Column dataField="itemDate2" caption="Item Date 2" visible={false} />
                <Column dataField="itemDate3" caption="Item Date 3" visible={false} />
                <Column dataField="itemDate4" caption="Item Date 4" visible={false} />
                <Column dataField="itemDate5" caption="Item Date 5" visible={false} />
                <Column dataField="itemDate6" caption="Item Date 6" visible={false} />
                <Column dataField="itemDate7" caption="Item Date 7" visible={false} />
                <Column dataField="itemDate8" caption="Item Date 8" visible={false} />
                <Column dataField="itemDate9" caption="Item Date 9" visible={false} />
                <Column dataField="itemDate10" caption="Item Date 10" visible={false} />
                <Column dataField="itemQuantity1" caption="Item Quantity 1" visible={false} />
                <Column dataField="itemQuantity2" caption="Item Quantity 2" visible={false} />
                <Column dataField="itemQuantity3" caption="Item Quantity 3" visible={false} />
                <Column dataField="itemQuantity4" caption="Item Quantity 4" visible={false} />
                <Column dataField="itemQuantity5" caption="Item Quantity 5" visible={false} />
                <Column dataField="itemQuantity6" caption="Item Quantity 6" visible={false} />
                <Column dataField="itemQuantity7" caption="Item Quantity 7" visible={false} />
                <Column dataField="itemQuantity8" caption="Item Quantity 8" visible={false} />
                <Column dataField="itemQuantity9" caption="Item Quantity 9" visible={false} />
                <Column dataField="itemQuantity10" caption="Item Quantity 10" visible={false} />  


                <Toolbar>
                <Item location="before">
                    <Button text="Edit" disabled={!showPopup.id} type="default" onClick={()=>setShowPopup(prevFormData=>({...prevFormData, visible:true}))} />
                </Item>
                <Item location="before">
                     <Button text="Add" type="default" onClick={()=>setShowPopup({id:null, visible:true})}/>
                    </Item>
                    <Item location="before">
                    <PrintReportMenu selectedRecord={selectedRecord} />
                    </Item>
                    <Item location="before">
                    <SalesOrderOptionsButton tabType={OptionsTabType.Item} customerId={null} />
                    </Item>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
            <ItemLotTabs ref={childRef} accessToken={accessToken} />
            <LotDataEntryPopup showPopup={showPopup} setShowPopup={setShowPopup}/>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemLotSearchResult);